module.exports = __webpack_public_path__ + "img/MilitaryTabRollover_ua.95bfff0f.webp";